import type { VendorPayment } from '@/redux/service/vendor'

/* A project's "full" payment row is the one with no linked milestone and
   no linked ClickUp task - the exact invariant the backend enforces when
   auto-creating it (controller/project.controller.js, INSERT ... WHERE
   project_milestone_id IS NULL AND clickup_task_id IS NULL). Switching a
   vendor between 'milestone' and 'full' payment types never deletes the
   old rows ("payment history survives it"), so getVendorPayments can
   return old milestone rows alongside the full-payment row - rows[0] is
   not reliably the full-payment record once that's happened. */
export const findFullPaymentRecord = (payments: VendorPayment[]) =>
  payments.find(
    p => p.project_milestone_id == null && p.clickup_task_id == null
  )
